<template>
    <layout-card
        :error="error"
        :isCustomizable="settings.isCustomizable"
        :type="settings.context"
        @hide-card="$emit('hide-card', 'activity')"
        @refresh-card="fetchCard('activity', {}, true)"
        class="card-activity"
        :loading="loading"
    >
        <template #title>
            {{ name }}
        </template>
        <template #content>
            <ul v-if="cardData && cardData.length > 0">
                <li v-for="staff in cardData" :key="staff.userid" class="activity">
                    <a :href="`/staff/${staff.userid}`">
                        <p>
                            <span class="chip" :class="isActive(staff.lastActivity)"></span>
                            {{ staff.forename }} {{ staff.name }}
                        </p>
                        <p class="details">
                            <span
                                >{{ $l10n.__('Dernière activité :') }}
                                {{
                                    $filters.dateFormatter(
                                        staff.lastActivity,
                                        'NORMAL_DATE_TIME',
                                        false,
                                    )
                                }}</span
                            >
                        </p>
                    </a>
                </li>
            </ul>
        </template>
    </layout-card>
</template>

<script>
import LayoutCard from './LayoutCard.vue';
import CardMixin from './CardMixin.js';

export default {
    mixins: [CardMixin],
    data() {
        return {};
    },
    methods: {
        isActive(date) {
            if (moment(date, 'X').add(1, 'hours').isAfter()) {
                return 'chip-success';
            } else {
                return 'chip-warning';
            }
        },
    },
    components: {
        LayoutCard,
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';
@import '~@sellsy/styleguide/src/_mixins';

ul {
    flex: 1;
    overflow: scroll;

    .activity {
        a {
            display: block;
            color: $gray-100;
            padding: spacer(2);
            @include border-radius();

            &:hover {
                background-color: $primary-05;
                cursor: pointer;
            }

            p {
                margin: spacer(1) 0;
            }
            .status,
            .details {
                margin: 0;
                color: $gray-60;
            }

            .details span {
                margin-right: spacer(3);
                &:last-of-type {
                    margin-right: 0;
                }
            }
        }
    }
}
</style>
